import { Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React, { SFC } from 'react'

import './loading-indicator.scss'

// TODO: - RK - move this component out of the modules/forms to app/shared folder - after suggest refactoring similar to multiselect

type Props = {}

const LoadingIndicator: SFC<Props> = () => {
  return (
    <div className="loading-indicator">
      <Icon icon={IconNames.REFRESH} className="loading-indicator--spin" title={false} />
    </div>
  )
}

export { LoadingIndicator }



// WEBPACK FOOTER //
// ./src/modules/forms/loading-indicator.tsx